/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, useState, useEffect } from 'react';
import * as RadioGroup from '@radix-ui/react-radio-group';
import { Box, Button, BrowserFrame, Text, Masonry, Vertical } from '@components/design-system';
import { SelectorThemeTypes } from '@components/selector-theme';
import { setItem } from '@utils/localstorage';
import { ISlide } from './interface';
import { RadioItem } from './radio-item';

export const Theme: FC<ISlide> = ({ values, handleStep }) => {
  const [defaultValue, setDefaultValue] = useState<string>(SelectorThemeTypes.system);

  const changeTheme = (theme: string) => {
    setItem('--versum-theme', theme);
    setDefaultValue(theme);

    if (theme !== SelectorThemeTypes.system) {
      document.documentElement.dataset.theme = theme;
    } else {
      delete document.documentElement.dataset.theme;
    }
  };

  useEffect(() => {
    setDefaultValue(document.documentElement.dataset.theme || SelectorThemeTypes.system);
  }, []);

  return (
    <>
      <Box css={{ width: '100%', backgroundColor: '$secondaryBackground' }} horizontal>
        <Box css={{ marginTop: 32, height: 150, overflow: 'hidden' }}>
          <BrowserFrame>
            {values.masonry ? (
              <Masonry info={values.info} market={values.market} labels={values.labels} />
            ) : (
              <Vertical info={values.info} market={values.market} labels={values.labels} />
            )}
          </BrowserFrame>
        </Box>
      </Box>

      <Box css={{ width: '100%', padding: '$space$3', flexDirection: 'column' }}>
        <Text as="h6" css={{ textAlign: 'center' }}>
          Theme
        </Text>

        <Text css={{ color: '$secondaryFill', fontSize: 14, textAlign: 'center' }}>Choose your preference</Text>

        <RadioGroup.Root value={defaultValue} onValueChange={changeTheme} asChild>
          <Box
            css={{
              width: '100%',
              flexDirection: 'column',
              '&>*': { marginBottom: '$space$4', '&:last-child': { marginBottom: 'unset' } },
            }}
          >
            <RadioItem value="system" label="System" />
            <RadioItem value="dark" label="Dark" />
            <RadioItem value="light" label="Light" />
          </Box>
        </RadioGroup.Root>
      </Box>

      <Box css={{ padding: '$space$3', justifyContent: 'space-between' }} vertical>
        <Box css={{ color: '$secondaryFill', fontSize: 12 }}>5 / 5</Box>
        <Box>
          <Button variant="simple" onClick={() => handleStep && handleStep(-1)}>
            Back
          </Button>
          <Button variant="secondary" onClick={() => handleStep && handleStep(+1)}>
            Finish
          </Button>
        </Box>
      </Box>
    </>
  );
};
